export default {
  DOMAIN_SUFFIX: process.env.REACT_APP_DOMAIN_SUFFIX || "",
  DOMAIN_PROTOCOL: process.env.REACT_APP_DOMAIN_PROTOCOL || "",
};
